import { useMediaQuery } from '@mui/material';
import { Tab, Tabs } from '@mui/material';
import { Box, Button, CircularProgress, Modal, TextField } from '@mui/material';
import { IconButton, Switch, Checkbox } from '@mui/material';
import { Typography } from '@mui/material';
import { TracksPageProps, filterAndSort } from './types';
import { useCallback } from 'react';
import { useContext, useEffect, useRef, useState } from 'react';
import { FilterMenu } from '../../components/TracksPageComponents/FilterMenu';
import { SortMenu } from '../../components/TracksPageComponents/SortMenu';
import { AuthContext, UserDetailsContext } from '../../contexts';
import useGetValidAccessToken from '../../hooks/useGetValidAccessToken';
import { CustomTracksPageHeadingContainer } from './styles';
import { CustomTracksListContainer } from './styles';
import { CustomTracksScrollingContainer } from './styles';
import { MobileScreenBottomNavigationContainer } from './styles';
import { styles } from './styles';
import { TrackListView } from '../../components/TracksPageComponents/TrackListView';
import { fetchCollaboratorsForUser, getModalMessage, handlePublish } from './tracksHandler';
import { getTracks } from './tracksHandler';
import { fetchArtistsForUser } from './tracksHandler';
import { TrackVersionsObj } from '../MyTracks/types';
import { TrackFilterParams, TrackObj } from '../MyTracks/types';
import { FilterAndSortDetails } from '../../components/TracksPageComponents/FilterAndSortDetails';
import { TracksSearchBar } from '../../components/TracksPageComponents/TracksSearchBar';
import { AddMusicSection } from '../../components/TracksPageComponents/AddMusicSection';
import CloseIcon from '@mui/icons-material/Close';
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import { AddMusicSectionStyles } from '../../components/TracksPageComponents/styles';
import { ControllersContainer } from '../../components/TracksPageComponents/styles';
import { TracksPageMainContainer } from '../../components/TracksPageComponents/styles';
import useInfiniteScroll from '../../hooks/useInfiniteScroll';
import { MobileScreenBottomNavigation } from '../../components/TracksPageComponents/MobileScreenBottomNavigation';
import { AddTrackVersionModal } from '../../components/Modal/AddTrackVersionModal';
import {
  FileState,
  Folder,
  GetFoldersResponse,
  GetTotalTracksAndFilesCountResponse,
  LinkFoldersToProjectResponse,
  UpdateProjectFilesResponse,
  CreateProjectResponse,
} from '../../proto/api_pb';
import { ProjectFile, Role, TrackState } from '../../proto/api_pb';
import { UpdateTrackPositionResponse } from '../../proto/api_pb';
import { Track } from '../../proto/api_pb';
import CollabModal from '../../components/Modal/CollabModal';
import { TrackToPlay } from '../ExplorePage/types';
import { AudioDetails } from '../../components/TracksPageComponents/types';
import { AudioPlayer } from '../../components/TracksPageComponents/AudioPlayer';
import TrackAddModal from '../../components/Modal/TrackAddModal';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import BatchTrackAddModal from '../../components/Modal/BatchTrackModal';
import BatchEditModal from '../../components/Modal/BatchEditModal';
import ConfirmationMessageModal from '../../components/Modal/ConfirmationMessageModal';
import { MobileDrawer } from '../../components/MobileDrawer/MobileDrawer';
import { UpdateTrackPosition } from '../../services/reorderService';
import { UpdateSubModal } from '../../components/Modal/UpdateSubModal';
import { SelectVersionDeleteModal } from '../../components/Modal/SelectVersionDeleteModal';
import { a11yProps } from '../../components/TracksPageComponents/CustomTabPanel';
import { CustomTabPanel } from '../../components/TracksPageComponents/CustomTabPanel';
import { FilesSection } from '../../components/TracksPageComponents/FilesSection';
import { AddItemsModal } from '../../components/Modal/AddItemsModal';
import { splitSheetStyles } from '../../components/Modal/styles';
import { SubscriptionInfoModal } from '../../components/Modal/SubscriptionInfoModal';
import PostAddIcon from '@mui/icons-material/PostAdd';
import {
  linkFolderToProjectOrFolder,
  updateProjectFiles,
  addProject,
} from '../../services/projectService';
import { toast } from 'react-toastify';
import { projectPageStyles } from '../Projects/styles';
import { TEXT_COLOR, BORDER_COLOR, APP_COLOR } from '../../theme';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { addProjectModalStyles } from '../../components/Modal/styles';
import { getFolderArtwork } from '../../services/trackService';
import { ProjectFileFilterMenu } from '../Projects/ProjectFileFilterMenu';
import { ProjectFileSearchBar } from '../../components/SingleProject/ProjectFileSearchbar';
import { ProjectFilesSortMenu } from '../../components/SingleProject/ProjectFilesSortMenu';
import { FileStateReverseMap } from '../../components/SingleProject/types';
import DeleteConfirmationModal from '../../components/Modal/DeleteConfirmationModal';
import CustomButton from '../../components/CustomButton/CustomButton';
import AddFolderModal from '../../components/Modal/AddFolderModal';
import { getAllFolders, deleteFolder } from '../../services/folderService';
import BatchEditFolderModal from '../../components/Modal/BatchEditFolderModal';
import { TracksTableHeadings } from '../../components/TracksPageComponents/TracksTableHeadings';
import { FolderSection } from '../../components/TracksPageComponents/FolderSection';
import { VideoUpload } from '../../components/TracksPageComponents/VideoUpload';
import { Breadcrumbs } from '../../components/BreadCrumbs/BreadCrumbs';
import TotalTracksCount from '../../components/TracksPageComponents/TotalTracksCount';
import AssetCount from '../../components/TracksPageComponents/AssetCount';
import { isBillingRequired } from '../../utils/subscriptionBillingUtils';
import { getTotalTracksCount } from '../../services/trackService';
import { getStorageUsage } from '../../services/storageService';
import Mixpanel from '../../utils/mixpanel';
import { useGetUser } from '../../hooks/useGetUser';
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

export const TracksPage: React.FC<TracksPageProps> = ({
  setUploadingFilesDetailsList,
  setIsUploading,
  setUploadingCardsStatusList,
  session,
  setInbox,
  setIsUploadProcessing,
  openFoldersList,
  setOpenFoldersList,
  setFolderUploadInfo,
  getStorageUsed,
}) => {
  // Track Related states :
  const [tracks, setTracks] = useState<TrackObj[]>([]);
  const [selectedTrack, setSelectedTrack] = useState<Track>();
  const [selectedTrackUrl, setSelectedTrackUrl] = useState('');
  const [trackToPlay, setTrackToPlay] = useState<TrackToPlay>();
  const [isTrackForPlay, setIsTrackForPlay] = useState<boolean>(true);
  const [versionToPlay, setVersionToPlay] = useState<TrackVersionsObj>();
  const [trackToExpand, setTrackToExpand] = useState('');
  const [selectedTrackLatestVersion, setSelectedTrackLatestVersion] = useState(0);
  const [draggedTrackIndex, setDraggedTrackIndex] = useState<number | null>(null);

  // File/Folder-related state
  const [checkedFiles, setCheckedFiles] = useState<ProjectFile[]>([]);
  const [folders, setFolders] = useState<Folder[]>([]);
  const [selectedFolders, setSelectedFolders] = useState<string[]>([]);
  const [selectedFoldersForProjects, setSelectedFoldersForProjects] = useState<Set<string>>(
    new Set()
  );
  const [bulkActionMode, setBulkActionMode] = useState<'create' | 'edit' | 'delete' | null>(null);
  const [isCreatingProjects, setIsCreatingProjects] = useState<boolean>(false);
  const [isBatchDeleteConfirmOpen, setIsBatchDeleteConfirmOpen] = useState<boolean>(false);
  const [isBatchEditModalOpen, setIsBatchEditModalOpen] = useState<boolean>(false);
  const [isBatchDeleting, setIsBatchDeleting] = useState<boolean>(false);
  const [isProjectNameModalOpen, setIsProjectNameModalOpen] = useState<boolean>(false);
  const [newProjectName, setNewProjectName] = useState<string>('');
  const [createProjectMode, setCreateProjectMode] = useState<'single' | 'perFolder'>('single');
  const [isProjectNameEmptyError, setIsProjectNameEmptyError] = useState<boolean>(false);
  const [filesSortBy, setFilesSortBy] = useState<0 | 1 | 2>(1);
  const [filesSortingIsAscending, setFilesSortingIsAscending] = useState(false);

  // Selection & Public/Private
  const [checkedTracks, setCheckedTracks] = useState<TrackObj[]>([]);
  const [isAllTracksSelected, setIsAllTracksSelected] = useState(false);
  const [isAllFilesSelected, setIsAllFilesSelected] = useState(false);
  const [isTracksPublic, setIsTracksPublic] = useState(false);

  // Modal-related state
  const [modals, setModals] = useState({
    collabs: false,
    singleTrack: false,
    message: false,
    updateSub: false,
    batchTrack: false,
    confirmation: false,
    selectDelete: false,
    version: false,
    batchEdit: false,
  });

  // Player/Audio state
  const [isPlayButtonClicked, setIsPlayButtonClicked] = useState<boolean>(false);
  const [audioDetails, setAudioDetails] = useState<AudioDetails>();

  // Filter/Sort/Search
  const [filter, setFilter] = useState<string>('');
  const [queryValue, setQueryValue] = useState<string>('');
  const [projectQueryValue, setProjectQueryValue] = useState<string>('');
  const [filterAndSortChanged, setFilterAndSortChanged] = useState<boolean>(false);
  const [filterAndSortParams, setFilterAndSortParams] = useState<TrackFilterParams>(filterAndSort);
  const [isReorderAvailable, setIsReorderAvailable] = useState<boolean>(
    filterAndSortParams.sortBy === 'Custom Order'
  );

  // API/Processing state
  const [isLoading, setIsLoading] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isCountUpdated, setIsCountUpdated] = useState(false);
  const [isFilesUpdated, setIsFilesUpdated] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Miscellaneous;
  const [allArtistList, setAllArtistList] = useState<string[]>([]);
  const [collaboratorsOptionsList, setCollaboratorsOptionsList] = useState<string[]>([]);
  const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
  const [value, setValue] = useState(0);
  const [initialLand, setInitialLand] = useState(false);
  const [isAddFolderToProject, setIsAddFolderToProject] = useState(false);

  const isSmallScreen = useMediaQuery('(max-width:600px)');
  const loadingRef = useRef<HTMLDivElement | null>(null);
  const { userId } = useContext(AuthContext);
  const { getValidAccessToken } = useGetValidAccessToken();
  const { getUserResponse } = useGetUser(userId, false);
  const { subscriptionTier, isEnterpriseAccount, enterprise, role, storageUsage } =
    useContext(UserDetailsContext);
  const isMediumScreen = useMediaQuery('(max-width: 1336px)');
  const { page, scrollContainerRef, setIsScrollEnabled, isScrollEnabled, setPage } =
    useInfiniteScroll();
  const ref = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { projectId, projectName, folderIdFromNavigation } = location.state || {};
  const { name, id, folderId } = useParams();
  const isAddToProjectPage =
    (window.location.pathname.includes('my-tracks') && folderIdFromNavigation) || projectId;
  const isHubPage = window.location.pathname.includes('my-tracks');
  const isHubPageAndFolderOpen = window.location.pathname.includes('untitled');

  const handleChange = async (event: React.SyntheticEvent, newValue: number) => {
    setIsAllTracksSelected(false);
    setIsAllFilesSelected(false);
    if (!isAddToProjectPage) setCheckedTracks([]);
    if (!isAddToProjectPage) setCheckedFiles([]);
    setFilterAndSortParams(filterAndSort);
    setQueryValue('');
    setValue(newValue);
    setTracks([]);
    setIsLoading(true);
    sessionStorage.setItem('TabValue', JSON.stringify(newValue));
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const plan = params.get('plan');
    setInitialLand(plan === 'trial-major');
    const previousTabValue = sessionStorage.getItem('TabValue')
      ? JSON.parse(sessionStorage.getItem('TabValue')!)
      : null;
    if (previousTabValue !== null) {
      if (previousTabValue === 0) {
        setValue(0);
      } else if (previousTabValue === 1) {
        setValue(1);
      } else if (previousTabValue === 2) {
        setValue(2);
      } else if (previousTabValue === 3) {
        setValue(3);
      }
    }
  }, []);

  const handleClosePlayerForModal = () => {
    setIsPlayButtonClicked(false);
    setIsTrackForPlay(false);
    setTrackToPlay(undefined);
  };
  const isBoxChecked = (item: TrackObj): boolean => {
    return checkedTracks.findIndex((t) => t.track?.getId() === item.track?.getId()) !== -1;
  };

  const isFileChecked = (item: ProjectFile): boolean => {
    return checkedFiles.findIndex((t) => t.getId() === item.getId()) !== -1;
  };
  const handleExpandTrack = (trackId: string) => {
    setTrackToExpand((prevId) => (prevId === trackId ? '' : trackId));
  };

  const handleRefreshTracks = async () => {
    console.log('Refreshing tracks');

    // Validate role conversion
    const roleAsNumber = isEnterpriseAccount && role ? Number(role) : undefined;
    const isValidRole =
      roleAsNumber !== undefined && !isNaN(roleAsNumber) && roleAsNumber >= 0 && roleAsNumber <= 2;

    console.log('Role-based filtering:', {
      isEnterpriseAccount,
      enterpriseId: enterprise?.id,
      role: role,
      roleNumber: roleAsNumber,
      isValidRole,
      roleDescription:
        roleAsNumber === 0
          ? 'ARTIST'
          : roleAsNumber === 1
            ? 'MANAGER'
            : roleAsNumber === 2
              ? 'ADMIN'
              : 'INVALID',
      userId,
    });

    if (isEnterpriseAccount && !isValidRole) {
      console.error('❌ Invalid role detected! Role filtering may not work correctly.');
    }

    setIsLoading(true);
    setIsCountUpdated(true);
    setPage(0);
    setTracks([]);
    const token = await getValidAccessToken();
    await getTracks(
      userId,
      filterAndSort,
      token,
      setTracks,
      0,
      setIsScrollEnabled,
      '',
      setIsLoading,
      !isHubPage ? id : undefined,
      isEnterpriseAccount ? enterprise?.id : undefined,
      isEnterpriseAccount ? Number(role) : undefined,
      value === 2 ? true : false,
      ''
    );
  };

  const handleCloseCollabsModal = () => {
    setModals((prev) => ({ ...prev, collabs: false }));
    clearSelectedTrack();
  };

  const handleOpenMessageModal = () => {
    setModals((prev) => ({ ...prev, message: true }));
  };

  const handleOpenCollabsModal = (tr: TrackObj) => {
    // setEvokeCallBack((prev) => prev + 1);

    handleClosePlayerForModal();
    setModals((prev) => ({ ...prev, collabs: true }));
    setSelectedTrack(tr.track);
  };
  const handleOpenSelectDeleteModal = (tr: TrackObj) => {
    handleClosePlayerForModal();
    setModals((prev) => ({ ...prev, confirmation: true }));
    setSelectedTrack(tr.track);
  };
  const handleOpenEditTrackModal = (tr: TrackObj) => {
    handleClosePlayerForModal();
    setModals((prev) => ({ ...prev, singleTrack: true }));
    setSelectedTrack(tr.track);
    setSelectedTrackUrl(tr.trackUrl);
  };

  const handleOpenUpdateSubModal = () => {
    if (isEnterpriseAccount) return;
    handleClosePlayerForModal();
    setModals((prev) => ({ ...prev, updateSub: true }));
  };

  const handleCloseUpdateSubModal = () => {
    setModals((prev) => ({ ...prev, updateSub: false }));
  };

  const handleCloseInfoSubModal = () => {
    setInitialLand(false);
  };

  const handleAscendingOrDescending = () => {
    setPage(0);
    setTracks([]);
    setFilterAndSortParams((prev) => {
      return {
        ...prev,
        isAscending: !filterAndSortParams.isAscending,
      };
    });
  };

  useEffect(() => {
    const handleUseEffect = async () => {
      const token = await getValidAccessToken();
      fetchArtistsForUser(token, userId, setAllArtistList);
      fetchCollaboratorsForUser(token, userId, setCollaboratorsOptionsList);
    };
    handleUseEffect();
  }, [getValidAccessToken, userId]);

  const handleFetchTracks = useCallback(async () => {
    if (value === 1) return;
    if (!filterAndSortChanged && queryValue === '' && userId) {
      setIsLoading(true);
      const token = await getValidAccessToken();
      await getTracks(
        userId,
        filterAndSort,
        token,
        setTracks,
        page,
        setIsScrollEnabled,
        '',
        setIsLoading,
        !isHubPage ? id : undefined,
        isEnterpriseAccount ? enterprise?.id : undefined,
        isEnterpriseAccount ? Number(role) : undefined,
        value === 2 ? true : false,
        folderId
      );
    }
  }, [
    enterprise?.id,
    filterAndSortChanged,
    folderId,
    getValidAccessToken,
    id,
    isEnterpriseAccount,
    isHubPage,
    page,
    queryValue,
    role,
    setIsScrollEnabled,
    userId,
    value,
  ]);

  const handleApplyFilterAndSort = useCallback(async () => {
    if (
      filterAndSortParams.isAscending === false &&
      filterAndSortParams.genreList.length === 0 &&
      filterAndSortParams.artistList.length === 0 &&
      filterAndSortParams.collaboratorsList.length === 0 &&
      filterAndSortParams.TrackPrivacy === 'All' &&
      filterAndSortParams.bpmStartValue === 0 &&
      filterAndSortParams.bpmEndValue === 200 &&
      filterAndSortParams.sortBy === 'Notifications' &&
      filterAndSortParams.status === ''
    ) {
      return;
    } else {
      if (filterAndSortChanged) {
        setIsLoading(true);
        const token = await getValidAccessToken();
        await getTracks(
          userId,
          filterAndSortParams,
          token,
          setTracks,
          page,
          setIsScrollEnabled,
          queryValue,
          setIsLoading,
          id === 'undefined' ? '' : (id ?? ''),
          isEnterpriseAccount ? enterprise?.id : undefined,
          isEnterpriseAccount ? Number(role) : undefined,
          value === 2 ? true : false,
          folderId
        );
        setIsLoading(false);
      }
    }
  }, [
    enterprise?.id,
    filterAndSortChanged,
    filterAndSortParams,
    folderId,
    getValidAccessToken,
    id,
    isEnterpriseAccount,
    page,
    queryValue,
    role,
    setIsScrollEnabled,
    userId,
    value,
  ]);

  useEffect(() => {
    if (filterAndSortChanged) {
      handleApplyFilterAndSort();
    }
  }, [filterAndSortChanged, handleApplyFilterAndSort]);

  const clearSelectedTrack = () => {
    setSelectedTrack(undefined);
    setSelectedTrackUrl('');
  };

  const handleOpenTrackVersionModal = (tr: Track, latestVersionNumber: number) => {
    if (isBillingRequired(subscriptionTier, storageUsage) && !isEnterpriseAccount) {
      setModals((prev) => ({ ...prev, updateSub: true }));
    } else {
      handleClosePlayerForModal();
      setSelectedTrackLatestVersion(latestVersionNumber);
      setSelectedTrack(tr);
      setModals((prev) => ({ ...prev, version: true }));
    }
  };

  const handleCloseTrackVersionModal = () => {
    setModals((prev) => ({ ...prev, version: false }));
    clearSelectedTrack();
  };

  const handleCloseTrackAddModal = () => {
    setModals((prev) => ({ ...prev, singleTrack: false }));
    clearSelectedTrack();
  };
  const handleCloseBatchTrackAddModal = () => {
    setModals((prev) => ({ ...prev, batchTrack: false }));
    clearSelectedTrack();
    setHubDroppedFiles([]);
  };

  const handleCloseBatchEditModal = () => {
    setModals((prev) => ({ ...prev, batchEdit: false }));
    setCheckedTracks([]);
  };

  const handleOpenBatchTrackAddModal = () => {
    handleClosePlayerForModal();
    setModals((prev) => ({ ...prev, batchTrack: true }));
  };

  useEffect(() => {
    handleFetchTracks();
  }, [handleFetchTracks]);

  const handleCheckedTrackChange = (track: TrackObj, id: string) => {
    setCheckedTracks((prevTracks) => {
      const trackIndex = prevTracks.findIndex((t) => t.track?.getId() === id);
      if (trackIndex === -1) {
        return [...prevTracks, track];
      } else {
        const updatedTracks = [...prevTracks];
        updatedTracks.splice(trackIndex, 1);
        return updatedTracks;
      }
    });
  };

  const handleCheckedFileChange = (file: ProjectFile, id: string) => {
    setCheckedFiles((prevFiles) => {
      const fileIndex = prevFiles.findIndex((t) => t.getId() === id);
      if (fileIndex === -1) {
        return [...prevFiles, file];
      } else {
        const updatedFiles = [...prevFiles];
        updatedFiles.splice(fileIndex, 1);
        return updatedFiles;
      }
    });
  };

  const [isHubDragging, setIsHubDragging] = useState(false);
  const [hubDroppedFiles, setHubDroppedFiles] = useState<File[]>([]);

  const handleHubDragOver = (e: React.DragEvent) => {
    if (!e.dataTransfer.types.includes('Files')) return;
    e.preventDefault();
    setIsHubDragging(true);
  };

  const handleHubDragLeave = (e: React.DragEvent) => {
    if ((e.currentTarget as HTMLElement).contains(e.relatedTarget as Node)) return;
    setIsHubDragging(false);
  };

  const handleHubDrop = (e: React.DragEvent) => {
    if (!e.dataTransfer.types.includes('Files')) return;
    e.preventDefault();
    setIsHubDragging(false);
    const files = Array.from(e.dataTransfer.files);
    setHubDroppedFiles(files);
    handleOpenBatchTrackAddModal();
  };

  const handleDragStart = (index: number) => {
    setDraggedTrackIndex(index);
  };

  const handleDrop = async () => {
    if (isReorderAvailable) {
      if (draggedTrackIndex === null || draggedIndex === null) return;
      const updatedTracks = [...tracks];
      const [draggedTrack] = updatedTracks.splice(draggedTrackIndex, 1);
      updatedTracks.splice(draggedIndex, 0, draggedTrack);
      setTracks([]);
      setDraggedTrackIndex(null);
      const trackId = tracks[draggedTrackIndex].track?.getId();
      const token = await getValidAccessToken();
      setTracks(updatedTracks);
      if (trackId) {
        const response = await UpdateTrackPosition(
          token,
          userId,
          trackId,
          draggedIndex,
          isEnterpriseAccount ? enterprise?.id : undefined
        );
        if (response instanceof UpdateTrackPositionResponse) {
          console.log('updated tracks position');
        }
      }
    }
  };

  useEffect(() => {
    if (filterAndSortParams.sortBy === 'Custom Order') {
      setPage(0);
      setTracks([]);
      setIsReorderAvailable(true);
    } else {
      setPage(0);
      setTracks([]);
      setIsReorderAvailable(false);
    }
  }, [filterAndSortParams.sortBy, setPage]);

  useEffect(() => {
    const allPublished = checkedTracks.filter(
      (checkedTrack) => checkedTrack.track?.getState() === TrackState.TRACK_STATE_PUBLISHED
    );
    const isPublished = allPublished.length === checkedTracks.length ? true : false;
    setIsTracksPublic(isPublished);
  }, [checkedTracks]);

  const handleLinkFilesToProject = async () => {
    if (projectId && (checkedFiles.length > 0 || checkedTracks.length > 0)) {
      setIsProcessing(true);
      const token = await getValidAccessToken();
      checkedFiles.forEach((file) => {
        file.setProjectId(projectId);
        if (!file.getParentFolderIdList().includes(`root@${projectId}`)) {
          file.setParentFolderIdList([...file.getParentFolderIdList(), `root@${projectId}`]);
        }
      });
      const tracksToUpdate = checkedTracks
        .map((track) => track.track)
        .filter((track): track is Track => track !== undefined);
      tracksToUpdate.forEach((track) => {
        track.setProjectId(projectId);
        if (!track.getParentFolderIdList().includes(`root@${projectId}`)) {
          track.setParentFolderIdList([...track.getParentFolderIdList(), `root@${projectId}`]);
        }
      });
      const res = await updateProjectFiles(token, checkedFiles, tracksToUpdate);
      if (res instanceof UpdateProjectFilesResponse) {
        if (value === 0 || value === 2) {
          toast.info('Tracks Added To Project');
        } else {
          toast.info('Files Added To Project');
        }
        setCheckedFiles([]);
        navigate(`/project/${encodeURIComponent(projectName)}/${projectId}`);
      }
      setIsProcessing(false);
    } else {
      toast.info('No tracks or files selected');
    }
  };

  const handleLinkFoldersToProject = async () => {
    if (projectId && selectedFolders.length > 0) {
      setIsProcessing(true);
      const token = await getValidAccessToken();
      const res = await linkFolderToProjectOrFolder(
        token,
        projectId,
        selectedFolders,
        folderIdFromNavigation,
        userId,
        enterprise?.id ?? ''
      );
      if (res instanceof LinkFoldersToProjectResponse) {
        toast.info('Folders Added To Project');
        setSelectedFolders([]);
        setIsProcessing(false);
        if (folderIdFromNavigation) {
          navigate(
            `/project/${encodeURIComponent(
              projectName
            )}/${projectId}/folder/${folderIdFromNavigation}`
          );
        } else {
          navigate(`/project/${encodeURIComponent(projectName)}/${projectId}`);
          setTracks([]);
        }
      }
    } else {
      toast.info('No folders selected');
    }
  };

  const handleLinkFilesToFolder = async () => {
    if (folderIdFromNavigation && (checkedFiles.length > 0 || checkedTracks.length > 0)) {
      setIsProcessing(true);
      const token = await getValidAccessToken();
      checkedFiles.forEach((file) => {
        if (!file.getParentFolderIdList().includes(folderIdFromNavigation)) {
          file.setParentFolderIdList([...file.getParentFolderIdList(), folderIdFromNavigation]);
        }
        if (projectId !== 'undefined' && projectId !== '') file.setProjectId(projectId);
      });
      const tracksToUpdate = checkedTracks
        .map((track) => track.track)
        .filter((track): track is Track => track !== undefined);
      tracksToUpdate.forEach((track) => {
        if (!track.getParentFolderIdList().includes(folderIdFromNavigation)) {
          track.setParentFolderIdList([...track.getParentFolderIdList(), folderIdFromNavigation]);
        }
        if (projectId !== 'undefined' && projectId !== '') track.setProjectId(projectId);
      });
      const res = await updateProjectFiles(token, checkedFiles, tracksToUpdate);
      if (res instanceof UpdateProjectFilesResponse) {
        if (value === 0 || value === 2) {
          toast.info('Tracks Added To Folder');
        } else {
          toast.info('Files Added To Folder');
        }
        setCheckedFiles([]);
        navigate(
          `/project/${encodeURIComponent(
            projectName
          )}/${projectId}/folder/${folderIdFromNavigation}`
        );
      }
      setIsProcessing(false);
    } else {
      toast.info('No tracks or files selected');
    }
  };

  useEffect(() => {
    if (!isSmallScreen) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isSmallScreen]);

  const handleRemoveOrDeleteFiles = async () => {
    setIsSubmitting(true);
    const token = await getValidAccessToken();
    const allTracks: Track[] = checkedTracks
      .map((checkedTrack) => checkedTrack.track)
      .filter((track): track is Track => track !== undefined);
    if (isHubPage || id === 'undefined') {
      allTracks.forEach((element) => {
        element.setState(TrackState.TRACK_STATE_DELETED);
      });
      if (allTracks.length > 0) {
        toast.info('Track successfully deleted');
      }
    } else {
      allTracks.forEach((element) => {
        element.setProjectId('');
        const updatedFolderIds = element
          .getParentFolderIdList()
          .filter((id) => id !== folderId && id !== `root@${id}`);
        element.setParentFolderIdList(updatedFolderIds);
      });
      if (allTracks.length > 0) {
        toast.info('Track successfully removed');
      }
    }
    if (checkedFiles.length > 0) {
      if (isHubPage) {
        toast.info('File successfully deleted');
      } else {
        toast.info('File successfully removed');
      }
    }
    checkedFiles.forEach((file) => {
      file.setProjectId('');
      const updatedFolderIds = file
        .getParentFolderIdList()
        .filter((id) => id !== folderId && id !== `root@${id}`);
      file.setParentFolderIdList(updatedFolderIds);
      if (isHubPage) {
        file.setFileState(FileStateReverseMap[FileState.FILE_STATE_DELETED]);
      }
    });
    const totalFiles = checkedFiles.length > 0 ? checkedFiles : [];
    const totalTracks = allTracks.length > 0 ? allTracks : [];
    const res = await updateProjectFiles(token, totalFiles, totalTracks);
    if (res instanceof UpdateProjectFilesResponse) {
      setModals((prev) => ({ ...prev, confirmation: false }));
      setIsCountUpdated(true);
      setCheckedTracks([]);
      handleRefreshTracks();
      handleApplyFilterAndSort();
      const response = await getTotalTracksCount(token, userId, enterprise?.id);
      if (response instanceof GetTotalTracksAndFilesCountResponse) {
        const updatedTotalTracks = response.getTracksCount();
        const updatedTotalFiles = response.getFilesCount();
        const storageUse = await getStorageUsage(userId, token, enterprise?.id);
        if (getUserResponse) {
          Mixpanel.identify(getUserResponse.getUuid());
          if (isEnterpriseAccount) {
            const enterpriseName = enterprise?.name?.toLowerCase().replace(/\s+/g, '_');
            Mixpanel.people.set({
              [`storage_usage_${enterpriseName}`]: storageUse,
              [`total_tracks_${enterpriseName}`]: updatedTotalTracks,
              [`total_files_${enterpriseName}`]: updatedTotalFiles,
              last_uploaded: new Date().toISOString(),
            });
          } else {
            Mixpanel.people.set({
              storage_usage: storageUse,
              total_tracks: updatedTotalTracks,
              last_uploaded: new Date().toISOString(),
            });
          }
        }
      }
      if (value === 1) {
        setCheckedFiles([]);
        setIsFilesUpdated(true);
      }
    }
    getStorageUsed();
    setIsSubmitting(false);
  };

  const getAllFoldersForProject = useCallback(async () => {
    if (!enterprise || !enterprise.id) return;
    const token = await getValidAccessToken();
    const res = await getAllFolders(
      token,
      userId,
      id === 'undefined' ? '' : (id ?? ''),
      folderId,
      enterprise.id,
      isHubPage
    );
    if (res instanceof GetFoldersResponse) {
      setFolders(res.getFoldersList());
      setIsCountUpdated(true);
    }
  }, [enterprise, getValidAccessToken, userId, id, folderId, isHubPage]);

  useEffect(() => {
    if (isEnterpriseAccount && userId) {
      getAllFoldersForProject();
    }
  }, [getAllFoldersForProject, isEnterpriseAccount, userId]);

  const handleOpenProjectNameModal = useCallback(() => {
    if (selectedFoldersForProjects.size === 0) {
      toast.warn('Please select at least one folder to create a project from');
      return;
    }
    setIsProjectNameModalOpen(true);
  }, [selectedFoldersForProjects.size]);

  const handleCloseProjectNameModal = useCallback(() => {
    setIsProjectNameModalOpen(false);
    setNewProjectName('');
    setIsProjectNameEmptyError(false);
    setCreateProjectMode('single');
  }, []);

  const handleBulkCreateProjects = useCallback(async () => {
    if (!newProjectName.trim()) {
      setIsProjectNameEmptyError(true);
      toast.warn('Project name cannot be empty');
      return;
    }

    setIsCreatingProjects(true);
    setIsProjectNameModalOpen(false);
    const token = await getValidAccessToken();
    const folderIds = Array.from(selectedFoldersForProjects);

    try {
      let initialArtworkUrl = '';
      if (folderIds.length > 0) {
        initialArtworkUrl = await getFolderArtwork(token, folderIds[0], enterprise?.id ?? '');
      }
      if (!initialArtworkUrl) {
        initialArtworkUrl =
          isEnterpriseAccount && enterprise?.image
            ? enterprise.image
            : '/assets/images/logo512.png';
      }

      const res = await addProject(
        token,
        userId,
        newProjectName.trim(),
        '',
        [],
        initialArtworkUrl,
        enterprise?.id as string,
        []
      );

      if (res instanceof CreateProjectResponse) {
        const newProjectId = res.getProjectId();

        const linkRes = await linkFolderToProjectOrFolder(
          token,
          newProjectId,
          folderIds,
          '',
          userId,
          enterprise?.id ?? ''
        );

        if (linkRes instanceof LinkFoldersToProjectResponse) {
          toast.success(
            `Successfully created project "${newProjectName}" with ${folderIds.length} folder${folderIds.length > 1 ? 's' : ''}`
          );
          setBulkActionMode(null);
          setSelectedFoldersForProjects(new Set());
          setNewProjectName('');
          await getAllFoldersForProject();
        } else {
          toast.error('Failed to link folders to project');
        }
      } else {
        toast.error('Failed to create project');
      }
    } catch (error) {
      console.error('Error creating project from folders:', error);
      toast.error('Failed to create project');
    }

    setIsCreatingProjects(false);
  }, [
    newProjectName,
    selectedFoldersForProjects,
    getValidAccessToken,
    userId,
    enterprise,
    getAllFoldersForProject,
    isEnterpriseAccount,
  ]);

  const handleBulkCreateProjectsPerFolder = useCallback(async () => {
    const folderIds = Array.from(selectedFoldersForProjects);
    if (folderIds.length === 0) return;

    setIsCreatingProjects(true);
    setIsProjectNameModalOpen(false);
    const token = await getValidAccessToken();

    let successCount = 0;
    let failCount = 0;
    const batchSize = 10;

    for (let i = 0; i < folderIds.length; i += batchSize) {
      const batch = folderIds.slice(i, i + batchSize);
      await Promise.all(
        // eslint-disable-next-line no-loop-func
        batch.map(async (folderId) => {
          const folder = folders.find((f) => f.getId() === folderId);
          const folderName = folder?.getName() ?? folderId;
          try {
            let initialArtworkUrl = await getFolderArtwork(token, folderId, enterprise?.id ?? '');
            if (!initialArtworkUrl) {
              initialArtworkUrl =
                isEnterpriseAccount && enterprise?.image
                  ? enterprise.image
                  : '/assets/images/logo512.png';
            }

            const res = await addProject(
              token,
              userId,
              folderName,
              '',
              [],
              initialArtworkUrl,
              enterprise?.id as string,
              []
            );
            if (res instanceof CreateProjectResponse) {
              const newProjectId = res.getProjectId();
              const linkRes = await linkFolderToProjectOrFolder(
                token,
                newProjectId,
                [folderId],
                '',
                userId,
                enterprise?.id ?? ''
              );
              if (linkRes instanceof LinkFoldersToProjectResponse) {
                successCount++;
              } else {
                failCount++;
              }
            } else {
              failCount++;
            }
          } catch {
            failCount++;
          }
        })
      );
    }

    if (successCount > 0) {
      toast.success(`Successfully created ${successCount} project${successCount > 1 ? 's' : ''}`);
    }
    if (failCount > 0) {
      toast.error(`Failed to create ${failCount} project${failCount > 1 ? 's' : ''}`);
    }

    setBulkActionMode(null);
    setSelectedFoldersForProjects(new Set());
    await getAllFoldersForProject();
    setIsCreatingProjects(false);
  }, [
    selectedFoldersForProjects,
    folders,
    getValidAccessToken,
    userId,
    enterprise,
    getAllFoldersForProject,
    isEnterpriseAccount,
  ]);

  const handleSelectAllFoldersForProjects = useCallback(
    (checked: boolean) => {
      if (checked) {
        const allFolderIds = new Set(folders.map((f) => f.getId()).filter(Boolean));
        setSelectedFoldersForProjects(allFolderIds);
      } else {
        setSelectedFoldersForProjects(new Set());
      }
    },
    [folders]
  );

  const handleFolderCheckboxChange = useCallback((folderId: string, checked: boolean) => {
    setSelectedFoldersForProjects((prev) => {
      const newSet = new Set(prev);
      if (checked) {
        newSet.add(folderId);
      } else {
        newSet.delete(folderId);
      }
      return newSet;
    });
  }, []);

  const handleBulkDeleteFolders = useCallback(async () => {
    if (selectedFoldersForProjects.size === 0) return;
    setIsBatchDeleting(true);
    const token = await getValidAccessToken();
    const folderIds = Array.from(selectedFoldersForProjects);
    let failures = 0;

    for (const fId of folderIds) {
      try {
        await deleteFolder(token, fId);
      } catch (error) {
        console.error(`Failed to delete folder ${fId}:`, error);
        failures++;
      }
    }

    if (failures === 0) {
      toast.success(
        `Successfully deleted ${folderIds.length} folder${folderIds.length > 1 ? 's' : ''}`
      );
    } else {
      toast.warn(
        `Deleted ${folderIds.length - failures} of ${folderIds.length} folders. ${failures} failed.`
      );
    }

    setBulkActionMode(null);
    setSelectedFoldersForProjects(new Set());
    setIsBatchDeleteConfirmOpen(false);
    setIsBatchDeleting(false);
    await getAllFoldersForProject();
    setIsCountUpdated(true);
  }, [selectedFoldersForProjects, getValidAccessToken, getAllFoldersForProject]);

  useEffect(() => {
    const handleBackButton = () => {
      if (openFoldersList && openFoldersList.length > 0) {
        const updatedFolders = [...openFoldersList];
        updatedFolders.pop();
        setOpenFoldersList?.(updatedFolders);
        setTracks([]);
        localStorage.setItem('breadcrumbs', JSON.stringify(updatedFolders));
      }
    };

    window.addEventListener('popstate', handleBackButton);
    return () => window.removeEventListener('popstate', handleBackButton);
  }, [openFoldersList, setOpenFoldersList]);

  useEffect(() => {}, [selectedFolders]);

  return (
    <>
      <MobileDrawer />
      {(checkedTracks.length > 0 || checkedFiles.length > 0) && (
        <DeleteConfirmationModal
          isMessageModalOpen={modals.confirmation}
          message={getModalMessage(checkedTracks, checkedFiles)}
          toggle={() =>
            setModals((prev) => ({
              ...prev,
              confirmation: !modals.confirmation,
            }))
          }
          handleConfirm={handleRemoveOrDeleteFiles}
          loading={isSubmitting}
        />
      )}
      {modals.message && (
        <ConfirmationMessageModal
          isMessageModalOpen={modals.message}
          message="Your tracks are being processed, you will receive an email when they are done processing."
          toggle={() => {
            setModals((prev) => ({
              ...prev,
              message: !modals.message,
            }));
            if (isHubPage) handleRefreshTracks();
          }}
        />
      )}
      {modals.confirmation && selectedTrack && (
        <SelectVersionDeleteModal
          isModalOpen={modals.confirmation}
          handleCloseModal={() => {
            setModals((prev) => ({
              ...prev,
              confirmation: !modals.confirmation,
            }));
          }}
          selectedTrack={selectedTrack}
          handleRefreshTracks={handleRefreshTracks}
        />
      )}
      {modals.singleTrack && (
        <TrackAddModal
          trackToEdit={selectedTrack}
          trackToEditUrl={selectedTrackUrl}
          isModalOpen={modals.singleTrack}
          handleCloseTrackAddModal={handleCloseTrackAddModal}
          handleRefreshTracks={handleRefreshTracks}
        />
      )}
      {initialLand && !isEnterpriseAccount && (
        <SubscriptionInfoModal open={initialLand} handleCloseModal={handleCloseInfoSubModal} />
      )}
      {modals.updateSub && (
        <UpdateSubModal open={modals.updateSub} handleCloseModal={handleCloseUpdateSubModal} />
      )}
      {modals.batchTrack && (
        <BatchTrackAddModal
          isModalOpen={modals.batchTrack}
          handleCloseBatchTrackAddModal={handleCloseBatchTrackAddModal}
          setIsUploading={setIsUploading}
          setUploadingFilesDetailsList={setUploadingFilesDetailsList}
          setUploadingCardsStatusList={setUploadingCardsStatusList}
          handleOpenMessageModal={handleOpenMessageModal}
          setIsUploadProcessing={setIsUploadProcessing}
          setFolderUploadInfo={setFolderUploadInfo}
          getStorageUsed={getStorageUsed}
          droppedFiles={hubDroppedFiles}
        />
      )}
      {modals.collabs && (
        <CollabModal
          openCollabsModal={modals.collabs}
          handleCloseCollabsModal={handleCloseCollabsModal}
          trackToEdit={selectedTrack}
          handleFetchTrackFiles={handleRefreshTracks}
        />
      )}
      {modals.version && (
        <AddTrackVersionModal
          open={modals.version}
          handleTrackMenuClose={() => {}}
          handleCloseModal={handleCloseTrackVersionModal}
          track={selectedTrack}
          handleRefreshTracks={handleRefreshTracks}
          selectedTrackLatestVersion={selectedTrackLatestVersion}
        />
      )}
      {modals.batchEdit && (
        <BatchEditModal
          isModalOpen={modals.batchEdit}
          checkedTracks={checkedTracks}
          handleClose={handleCloseBatchEditModal}
          handleRefresh={handleRefreshTracks}
        />
      )}
      <DeleteConfirmationModal
        isMessageModalOpen={isBatchDeleteConfirmOpen}
        message={`Are you sure you want to delete ${selectedFoldersForProjects.size} folder${selectedFoldersForProjects.size > 1 ? 's' : ''}?`}
        toggle={() => setIsBatchDeleteConfirmOpen(false)}
        handleConfirm={handleBulkDeleteFolders}
        loading={isBatchDeleting}
      />
      <BatchEditFolderModal
        open={isBatchEditModalOpen}
        onClose={() => {
          setIsBatchEditModalOpen(false);
          setBulkActionMode(null);
          setSelectedFoldersForProjects(new Set());
        }}
        selectedFolderIds={selectedFoldersForProjects}
        folders={folders}
        onSuccess={async () => {
          setBulkActionMode(null);
          setSelectedFoldersForProjects(new Set());
          await getAllFoldersForProject();
        }}
      />
      <Box
        ref={isSmallScreen ? scrollContainerRef : null}
        sx={
          isSmallScreen
            ? styles.mainScrollC
            : {
                display: 'flex',
                backgroundColor: projectId ? '#10222e' : '',
              }
        }
      >
        <TracksPageMainContainer>
          <Box
            sx={{
              height: '95%',
              width: isSmallScreen ? '90vw' : isMediumScreen ? '74vw' : 'calc(100vw - 365px)',
            }}
          >
            <CustomTracksPageHeadingContainer sx={{ flexDirection: isSmallScreen ? 'column' : '' }}>
              {isHubPage && (
                <Typography sx={{ fontWeight: 'bold', fontSize: '30px' }}>
                  Hub{' '}
                  {isEnterpriseAccount && (
                    <TotalTracksCount
                      getValidAccessToken={getValidAccessToken}
                      userId={userId}
                      enterpriseId={enterprise?.id}
                      isCountUpdated={isCountUpdated}
                      setIsCountUpdated={setIsCountUpdated}
                    />
                  )}
                </Typography>
              )}
              <Box
                sx={{
                  display: 'flex',
                  gap: '5px',
                  alignItems: isSmallScreen ? 'left' : 'center',
                  flexDirection: isSmallScreen ? 'column' : '',
                }}
              >
                <Breadcrumbs
                  setOpenFoldersList={setOpenFoldersList}
                  openFoldersList={openFoldersList}
                  handleRefreshTracks={handleRefreshTracks}
                  setTracks={setTracks}
                  folders={folders}
                />
                <AssetCount
                  projectId={folderId ? '' : id}
                  folderId={folderId ? folderId : ''}
                  isCountUpdated={isCountUpdated}
                  setIsCountUpdated={setIsCountUpdated}
                />
              </Box>
              <Box sx={AddMusicSectionStyles.buttonBox}>
                {!isHubPage && (
                  <>
                    <CustomButton
                      icon={PostAddIcon}
                      text={`Add Tracks & Files to ${folderId ? 'folder' : 'project'}`}
                      onClick={() => {
                        setIsAddFolderToProject(false);
                        navigate('/my-tracks', {
                          state: {
                            projectId: id,
                            projectName: name,
                            folderIdFromNavigation: folderId,
                          },
                        });
                      }}
                    />
                    {(!window.location.pathname.includes('untitled') ||
                      !window.location.pathname.includes('undefined')) && (
                      <CustomButton
                        icon={CreateNewFolderOutlinedIcon}
                        text="Add Folders"
                        onClick={() => {
                          setIsAddFolderToProject(true);
                          navigate('/my-tracks', {
                            state: {
                              projectId: id,
                              projectName: name,
                              folderIdFromNavigation: folderId,
                            },
                          });
                        }}
                      />
                    )}
                  </>
                )}

                {checkedTracks.length > 0 && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {/* ADD THIS NEW BUTTON */}
                    <CustomButton
                      onClick={(e) => {
                        e.stopPropagation();
                        setModals((prev) => ({
                          ...prev,
                          batchEdit: true, // You'll add this modal state
                        }));
                      }}
                      text={`Edit ${checkedTracks.length} Track${checkedTracks.length > 1 ? 's' : ''}    `}
                    ></CustomButton>
                  </Box>
                )}
                {isHubPage && (
                  <CustomButton
                    onClick={() => navigate('/share-management')}
                    text="Shared Assets"
                  />
                )}
                {(isHubPage ||
                  window.location.pathname.includes('untitled') ||
                  window.location.pathname.includes('undefined')) && (
                  <AddFolderModal
                    projectId={id ?? ''}
                    refreshFolders={getAllFoldersForProject}
                    folderId={folderId}
                    folders={folders}
                  />
                )}
                {isHubPage && (
                  <AddMusicSection
                    handleOpenBatchTrackAddModal={handleOpenBatchTrackAddModal}
                    handleOpenUpdateSubModal={handleOpenUpdateSubModal}
                  />
                )}
                {isEnterpriseAccount && isHubPage && (
                  <AddItemsModal
                    setUploadingFilesDetailsList={setUploadingFilesDetailsList}
                    setIsUploading={setIsUploading}
                    setUploadingCardsStatusList={setUploadingCardsStatusList}
                    setIsUploadProcessing={setIsUploadProcessing}
                    setFolderUploadInfo={setFolderUploadInfo}
                    getAllFoldersForProject={getAllFoldersForProject}
                    setIsFilesUpdated={setIsFilesUpdated}
                    setIsCountUpdated={setIsCountUpdated}
                    getStorageUsed={getStorageUsed}
                  />
                )}
              </Box>
            </CustomTracksPageHeadingContainer>
            <Box sx={projectPageStyles.filterContainerBox}>
              {!projectId && value === 1 && (
                <Box sx={projectPageStyles.filterContainer}>
                  <Box sx={{ margin: '9px 0px' }}>
                    <ProjectFileSearchBar
                      queryValue={projectQueryValue}
                      setQueryValue={setProjectQueryValue}
                    />
                    <ProjectFileFilterMenu filter={filter} setFilter={setFilter} />
                    <ProjectFilesSortMenu
                      filesSortBy={filesSortBy}
                      setFilesSortBy={setFilesSortBy}
                    />
                  </Box>
                  <Box sx={styles.fileCountContainer}>
                    {checkedFiles.length > 0 && (
                      <Box sx={styles.checkedFilesDetailsContainer}>
                        {checkedFiles.length} Files Selected
                      </Box>
                    )}
                    {checkedFiles.length > 0 && (
                      <Button
                        sx={projectPageStyles.deleteRemoveButton}
                        onClick={(e) => {
                          e.stopPropagation();
                          setModals((prev) => ({
                            ...prev,
                            confirmation: true,
                          }));
                        }}
                      >
                        {isHubPage || isHubPageAndFolderOpen ? 'Delete ' : 'Remove '}
                        {value === 1 ? 'Files' : 'Tracks'}
                      </Button>
                    )}
                  </Box>
                </Box>
              )}
              {!projectId && (
                <ControllersContainer
                  sx={{
                    display: value === 0 || value === 2 ? 'flex' : 'none',
                    ...styles.controllersContainer,
                  }}
                >
                  <Box
                    sx={{
                      ...styles.filtersContainer,
                      gap: isSmallScreen ? '10px' : '',
                    }}
                  >
                    <TracksSearchBar
                      setTracks={setTracks}
                      setPage={setPage}
                      queryValue={queryValue}
                      setQueryValue={setQueryValue}
                      setFilterAndSortChanged={setFilterAndSortChanged}
                    />
                    <Box sx={{ display: 'flex', gap: '10px' }}>
                      <FilterMenu
                        allArtistList={allArtistList}
                        collaboratorsOptionsList={collaboratorsOptionsList}
                        filterAndSortParams={filterAndSortParams}
                        setFilterAndSortParams={setFilterAndSortParams}
                        handleFiltersAndSort={handleApplyFilterAndSort}
                        setPage={setPage}
                        setTracks={setTracks}
                        value={value}
                      />
                      <SortMenu
                        setFilterAndSortParams={setFilterAndSortParams}
                        filterAndSortParams={filterAndSortParams}
                        setPage={setPage}
                        setTracks={setTracks}
                        setFilterAndSortChanged={setFilterAndSortChanged}
                        handleRefreshTracks={handleRefreshTracks}
                      />
                      {/* <AssetCount
                          getValidAccessToken={getValidAccessToken}
                        // projectId={id ?? ""}
                        // folderId={""}
                        /> */}
                    </Box>
                    {isHubPage && value === 0 && (
                      <Box sx={styles.reorderContainer}>
                        <Switch
                          {...label}
                          checked={isReorderAvailable}
                          onChange={() => {
                            setIsReorderAvailable(!isReorderAvailable);
                            if (!isReorderAvailable) {
                              setFilterAndSortChanged(true);
                              setPage(0);
                              setTracks([]);
                              setFilterAndSortParams((prev) => {
                                return {
                                  ...prev,
                                  sortBy: 'Custom Order',
                                };
                              });
                            } else {
                              setPage(0);
                              setTracks([]);
                              setFilterAndSortParams((prev) => {
                                return {
                                  ...prev,
                                  sortBy: 'Last modified',
                                };
                              });
                            }
                          }}
                        />
                        Custom Order
                      </Box>
                    )}
                  </Box>
                  <Box sx={styles.tracksCountSwitchContainer}>
                    {checkedTracks.length > 0 && (
                      <Box sx={styles.checkedTracksDetailsContainer}>
                        <Box sx={styles.checkTrackDetailsSwitchContainer}>
                          <Typography sx={{ fontSize: '14px' }}>
                            {checkedTracks.length} selected
                          </Typography>
                          <Switch
                            checked={isTracksPublic}
                            onChange={async () => {
                              setIsTracksPublic(!isTracksPublic);
                              const token = await getValidAccessToken();
                              await handlePublish(
                                checkedTracks,
                                token,
                                tracks,
                                userId,
                                isTracksPublic
                              );
                              setCheckedTracks([]);
                              await getTracks(
                                userId,
                                filterAndSortParams,
                                token,
                                setTracks,
                                page,
                                setIsScrollEnabled,
                                '',
                                setIsLoading,
                                !isHubPage ? id : undefined,
                                isEnterpriseAccount ? enterprise?.id : undefined,
                                isEnterpriseAccount ? Number(role) : undefined,
                                value === 2 ? true : false,
                                folderId
                              );
                              setIsTracksPublic(false);
                            }}
                            {...label}
                          />
                          <Typography sx={{ fontSize: '14px' }}>Make Public</Typography>
                          <IconButton
                            onClick={() => {
                              setCheckedTracks([]);
                              setIsAllTracksSelected(false);
                            }}
                            sx={{ margin: '5px' }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      </Box>
                    )}
                    {checkedTracks.length > 0 && (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Button
                          sx={projectPageStyles.deleteRemoveButton}
                          onClick={(e) => {
                            e.stopPropagation();
                            setModals((prev) => ({
                              ...prev,
                              confirmation: true,
                            }));
                          }}
                        >
                          {isHubPage || isHubPageAndFolderOpen ? 'Delete ' : 'Remove '}
                          {value === 1 ? 'Files' : 'Tracks'}
                        </Button>
                        <Button
                          sx={projectPageStyles.deleteRemoveButton}
                          onClick={(e) => {
                            e.stopPropagation();
                            setModals((prev) => ({
                              ...prev,
                              batchEdit: true,
                            }));
                          }}
                        >
                          Edit
                        </Button>
                      </Box>
                    )}
                  </Box>
                </ControllersContainer>
              )}
              {projectId && (
                <Box sx={styles.linkNotifyContainer}>
                  {value === 0 || value === 2 ? (
                    <>
                      <TracksSearchBar
                        setTracks={setTracks}
                        setPage={setPage}
                        queryValue={queryValue}
                        setQueryValue={setQueryValue}
                        setFilterAndSortChanged={setFilterAndSortChanged}
                      />
                      <Box
                        sx={{
                          // display: "flex",
                          display: projectId ? 'none' : 'flex',
                          gap: '10px',
                        }}
                      >
                        <FilterMenu
                          allArtistList={allArtistList}
                          collaboratorsOptionsList={collaboratorsOptionsList}
                          filterAndSortParams={filterAndSortParams}
                          setFilterAndSortParams={setFilterAndSortParams}
                          handleFiltersAndSort={handleApplyFilterAndSort}
                          setPage={setPage}
                          setTracks={setTracks}
                          value={value}
                        />
                        <SortMenu
                          setFilterAndSortParams={setFilterAndSortParams}
                          filterAndSortParams={filterAndSortParams}
                          setPage={setPage}
                          setTracks={setTracks}
                          setFilterAndSortChanged={setFilterAndSortChanged}
                          handleRefreshTracks={handleRefreshTracks}
                        />
                      </Box>
                    </>
                  ) : (
                    <ProjectFileSearchBar
                      queryValue={projectQueryValue}
                      setQueryValue={setProjectQueryValue}
                    />
                  )}

                  <Box sx={isSmallScreen ? { width: '100%' } : styles.linkNotifyIconContainer}>
                    <IconButton sx={{}}>
                      <PostAddIcon />
                    </IconButton>
                    <Typography>
                      Select the{' '}
                      {isAddFolderToProject ? 'folders' : `${value !== 1 ? 'tracks' : 'files'}`} you
                      want to add to the {projectName === 'untitled' ? `folder` : `${projectName}`}
                    </Typography>
                  </Box>
                  <Box sx={isSmallScreen ? { width: '100%' } : styles.linkButtonsContainer}>
                    <Button
                      onClick={() => {
                        value === 2 ? setValue(2) : setValue(0);
                        setIsAddFolderToProject(false);
                        setSelectedFolders([]);
                        setCheckedFiles([]);
                        setCheckedTracks([]);
                        setTracks([]);
                        folderIdFromNavigation
                          ? navigate(
                              `/project/${encodeURIComponent(
                                projectName
                              )}/${projectId}/folder/${folderIdFromNavigation}`
                            )
                          : navigate(`/project/${encodeURIComponent(projectName)}/${projectId}`);
                      }}
                      sx={{
                        ...styles.filterButton,
                        height: '40px',
                      }}
                    >
                      Back to {folderIdFromNavigation ? 'folder' : 'project'}
                    </Button>
                    {selectedFolders.length === 0 && !isAddFolderToProject && (
                      <Button
                        onClick={() => {
                          setCheckedTracks([]);
                          setIsCountUpdated(true);
                          setTracks([]);
                          if (value === 1) setValue(0);
                          folderIdFromNavigation
                            ? handleLinkFilesToFolder()
                            : handleLinkFilesToProject();
                        }}
                        disabled={checkedTracks.length === 0 && checkedFiles.length === 0}
                        sx={{
                          ...styles.button,
                          ...{
                            height: '40px',
                            fontSize: '15px',
                            width: '150px',
                          },
                        }}
                      >
                        {isProcessing ? (
                          <CircularProgress sx={{ color: 'black' }} size={25} />
                        ) : (
                          `Add selected ${value === 0 || value === 2 ? 'tracks' : 'files'}`
                        )}
                      </Button>
                    )}
                    {isEnterpriseAccount && isAddFolderToProject && (
                      <Button
                        onClick={() => {
                          setIsAddFolderToProject(false);
                          setSelectedFolders([]);
                          handleLinkFoldersToProject();
                        }}
                        disabled={selectedFolders.length === 0}
                        sx={{
                          ...styles.button,
                          ...{
                            height: '40px',
                            fontSize: '15px',
                            width: '150px',
                          },
                        }}
                      >
                        {isProcessing ? (
                          <CircularProgress sx={{ color: 'black' }} size={25} />
                        ) : (
                          `Add Selected Folders`
                        )}
                      </Button>
                    )}
                  </Box>
                </Box>
              )}
              <FilterAndSortDetails
                filterAndSortParams={filterAndSortParams}
                setFilterAndSortParams={setFilterAndSortParams}
                setPage={setPage}
                setTracks={setTracks}
                queryValue={queryValue}
                setQueryValue={setQueryValue}
                value={value}
              />
              {isHubPage && folders.length > 0 && (
                <Box
                  sx={{
                    display: 'flex',
                    gap: '10px',
                    alignItems: 'center',
                    marginBottom: '10px',
                    flexWrap: 'wrap',
                  }}
                >
                  {!bulkActionMode && (
                    <>
                      <CustomButton
                        text="Create Project"
                        onClick={() => setBulkActionMode('create')}
                        customStyles={{ height: '40px' }}
                      />
                      {Number(role) === Role.ROLE_ADMIN && (
                        <CustomButton
                          text="Edit"
                          onClick={() => setBulkActionMode('edit')}
                          customStyles={{ height: '40px' }}
                        />
                      )}
                      {Number(role) === Role.ROLE_ADMIN && (
                        <CustomButton
                          text="Delete"
                          onClick={() => setBulkActionMode('delete')}
                          customStyles={{ height: '40px' }}
                        />
                      )}
                    </>
                  )}
                  {bulkActionMode && (
                    <>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                        <Checkbox
                          checked={
                            selectedFoldersForProjects.size > 0 &&
                            selectedFoldersForProjects.size === folders.length
                          }
                          indeterminate={
                            selectedFoldersForProjects.size > 0 &&
                            selectedFoldersForProjects.size < folders.length
                          }
                          onChange={(e) => handleSelectAllFoldersForProjects(e.target.checked)}
                          sx={{
                            padding: '4px',
                            '& .MuiSvgIcon-root': {
                              fontSize: '20px',
                            },
                          }}
                        />
                        <Typography sx={{ fontSize: '14px', color: 'text.secondary' }}>
                          Select All ({selectedFoldersForProjects.size} selected)
                        </Typography>
                      </Box>
                      <IconButton
                        onClick={() => {
                          setBulkActionMode(null);
                          setSelectedFoldersForProjects(new Set());
                        }}
                        sx={{ color: 'text.secondary' }}
                      >
                        <Typography sx={{ fontSize: '14px' }}>Cancel</Typography>
                      </IconButton>
                      {bulkActionMode === 'create' && (
                        <CustomButton
                          text={
                            isCreatingProjects
                              ? 'Creating...'
                              : `Create Project${selectedFoldersForProjects.size > 1 ? ` (${selectedFoldersForProjects.size} folders)` : ''}`
                          }
                          onClick={handleOpenProjectNameModal}
                          loading={isCreatingProjects}
                          isDisabled={selectedFoldersForProjects.size === 0 || isCreatingProjects}
                          customStyles={{
                            height: '40px',
                            color: 'black',
                            '&.Mui-disabled': { color: 'black', opacity: 0.4 },
                          }}
                        />
                      )}
                      {bulkActionMode === 'edit' && (
                        <CustomButton
                          text={`Edit${selectedFoldersForProjects.size > 0 ? ` (${selectedFoldersForProjects.size} folders)` : ''}`}
                          onClick={() => {
                            if (selectedFoldersForProjects.size === 0) {
                              toast.warn('Please select at least one folder');
                              return;
                            }
                            setIsBatchEditModalOpen(true);
                          }}
                          isDisabled={selectedFoldersForProjects.size === 0}
                          customStyles={{
                            height: '40px',
                            color: 'black',
                            '&.Mui-disabled': { color: 'black', opacity: 0.4 },
                          }}
                        />
                      )}
                      {bulkActionMode === 'delete' && (
                        <CustomButton
                          text={`Delete${selectedFoldersForProjects.size > 0 ? ` (${selectedFoldersForProjects.size} folders)` : ''}`}
                          onClick={() => {
                            if (selectedFoldersForProjects.size === 0) {
                              toast.warn('Please select at least one folder');
                              return;
                            }
                            setIsBatchDeleteConfirmOpen(true);
                          }}
                          isDisabled={selectedFoldersForProjects.size === 0}
                          customStyles={{
                            height: '40px',
                            color: 'black',
                            '&.Mui-disabled': { color: 'black', opacity: 0.4 },
                          }}
                        />
                      )}
                    </>
                  )}
                </Box>
              )}
              <FolderSection
                folders={folders}
                isLoading={isLoading}
                setOpenFoldersList={setOpenFoldersList}
                setTracks={setTracks}
                setValue={setValue}
                value={value}
                getAllFoldersForProject={getAllFoldersForProject}
                selectedFolders={selectedFolders}
                setSelectedFolders={setSelectedFolders}
                isAddFolderToProject={isAddFolderToProject}
                isCountUpdated={isCountUpdated}
                setIsCountUpdated={setIsCountUpdated}
                bulkActionMode={bulkActionMode}
                selectedFoldersForProjects={selectedFoldersForProjects}
                onFolderCheckboxChange={handleFolderCheckboxChange}
              />
              <Box sx={{ width: '100%' }}>
                <Box>
                  <Tabs
                    TabIndicatorProps={{
                      style: { display: 'none' },
                    }}
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                    }}
                  >
                    <Tab
                      sx={{
                        ...splitSheetStyles.tab,
                        flex: isSmallScreen ? '1 1 50%' : '',
                        background:
                          value === 0 ? 'var(--Colors-Background-bg-active, #202425)' : undefined,
                      }}
                      label="Tracks"
                      {...a11yProps(0)}
                    />
                    {isEnterpriseAccount && (
                      <Tab
                        value={1}
                        sx={{
                          ...splitSheetStyles.tab,
                          flex: isSmallScreen ? '1 1 50%' : '',
                          background:
                            value === 1 ? 'var(--Colors-Background-bg-active, #202425)' : undefined,
                        }}
                        label="Other Files"
                        {...a11yProps(1)}
                      />
                    )}
                    {isEnterpriseAccount && (
                      <Tab
                        value={2}
                        sx={{
                          ...splitSheetStyles.tab,
                          flex: isSmallScreen ? '1 1 60%' : '',
                          background:
                            value === 2 ? 'var(--Colors-Background-bg-active, #202425)' : undefined,
                        }}
                        label="Completed Tracks"
                        {...a11yProps(2)}
                      />
                    )}
                    {/* B2C: Video tab hidden for individual users — enterprise only */}
                    {isEnterpriseAccount && (
                      <Tab
                        sx={{
                          ...splitSheetStyles.tab,
                          flex: isSmallScreen ? '1 1 50%' : '',
                          background:
                            value === 3 ? 'var(--Colors-Background-bg-active, #202425)' : undefined,
                        }}
                        label="Videos"
                        {...a11yProps(3)}
                      />
                    )}
                  </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                  <CustomTracksListContainer>
                    <TracksTableHeadings
                      filterAndSortParams={filterAndSortParams}
                      handleAscendingOrDescending={handleAscendingOrDescending}
                      isAllTracksSelected={isAllTracksSelected}
                      setCheckedTracks={setCheckedTracks}
                      tracks={tracks}
                      setIsAllTracksSelected={setIsAllTracksSelected}
                      isAddFolderToProject={isAddFolderToProject}
                    />
                    <CustomTracksScrollingContainer
                      onDragOver={handleHubDragOver}
                      onDragLeave={handleHubDragLeave}
                      onDrop={handleHubDrop}
                      sx={
                        isEnterpriseAccount
                          ? {
                              ...styles.bigScreenScrollC,
                              height: `calc(100vh - 280px - ${
                                folders.length === 0 ? 0 : folders.length < 8 ? 60 : 110
                              }px)`,
                              position: 'relative',
                            }
                          : {
                              ...styles.bigScreenScrollC,
                              height: 'calc(100vh - 230px)',
                              position: 'relative',
                            }
                      }
                      ref={!isSmallScreen ? scrollContainerRef : null}
                    >
                      {isHubDragging && tracks.length > 0 && (
                        <Box
                          sx={{
                            position: 'absolute',
                            inset: 0,
                            zIndex: 10,
                            border: `2px dashed ${APP_COLOR}`,
                            borderRadius: '12px',
                            backgroundColor: `${APP_COLOR}12`,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            pointerEvents: 'none',
                          }}
                        >
                          <CloudUploadIcon sx={{ fontSize: 56, color: APP_COLOR, mb: 1 }} />
                          <Typography sx={{ color: TEXT_COLOR, fontWeight: 'bold' }}>
                            Drop to add music
                          </Typography>
                        </Box>
                      )}
                      {tracks &&
                        tracks.length > 0 &&
                        tracks.map((track, i) => {
                          return (
                            <TrackListView
                              key={i}
                              index={i}
                              track={track}
                              isBoxChecked={isBoxChecked}
                              handleCheckedTrackChange={handleCheckedTrackChange}
                              handleRefreshTracks={handleRefreshTracks}
                              handleOpenTrackVersionModal={handleOpenTrackVersionModal}
                              handleOpenSelectDeleteModal={handleOpenSelectDeleteModal}
                              handleOpenCollabsModal={handleOpenCollabsModal}
                              handleOpenEditTrackModal={handleOpenEditTrackModal}
                              setIsPlayButtonClicked={setIsPlayButtonClicked}
                              trackToPlay={trackToPlay}
                              setTrackToPlay={setTrackToPlay}
                              setIsTrackForPlay={setIsTrackForPlay}
                              setVersionToPlay={setVersionToPlay}
                              setAudioDetails={setAudioDetails}
                              session={session}
                              setInbox={setInbox}
                              handleExpandTrack={handleExpandTrack}
                              expanded={trackToExpand === track.track?.getId()}
                              handleDragStart={handleDragStart}
                              handleDrop={handleDrop}
                              setDraggedIndex={setDraggedIndex}
                              isReorderAvailable={isReorderAvailable}
                              handleOpenUpdateSubModal={handleOpenUpdateSubModal}
                              versionToPlay={versionToPlay}
                              isAddFolderToProject={isAddFolderToProject}
                              handleApplyFilterAndSort={handleApplyFilterAndSort}
                              shareToken={''}
                              allowDownload={true}
                            />
                          );
                        })}
                      {tracks.length === 0 && !isLoading && !isScrollEnabled && (
                        <Box
                          onClick={handleOpenBatchTrackAddModal}
                          sx={{
                            border: `2px dashed ${isHubDragging ? APP_COLOR : BORDER_COLOR}`,
                            borderRadius: '12px',
                            padding: '40px 24px',
                            textAlign: 'center',
                            cursor: 'pointer',
                            backgroundColor: isHubDragging ? `${APP_COLOR}10` : 'transparent',
                            transition: 'border-color 0.2s, background-color 0.2s',
                            my: 3,
                            mx: 2,
                            '&:hover': {
                              borderColor: APP_COLOR,
                              backgroundColor: `${APP_COLOR}08`,
                            },
                          }}
                        >
                          <CloudUploadIcon sx={{ fontSize: 48, color: APP_COLOR, mb: 1 }} />
                          <Typography sx={{ color: TEXT_COLOR, fontWeight: 'bold', mb: 0.5 }}>
                            {isHubDragging ? 'Drop music here' : 'Drag & drop music here'}
                          </Typography>
                          <Typography sx={{ color: TEXT_COLOR, opacity: 0.6, fontSize: '0.85rem' }}>
                            or click to add music &mdash; mp3, wav, aiff, flac supported
                          </Typography>
                        </Box>
                      )}
                      {isLoading && (
                        <Box
                          ref={loadingRef}
                          sx={{
                            ...styles.loadingContainer,
                            ...{ height: isSmallScreen ? '40vh' : 'auto' },
                          }}
                        >
                          <CircularProgress size={50} />
                        </Box>
                      )}
                    </CustomTracksScrollingContainer>
                  </CustomTracksListContainer>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                  <FilesSection
                    session={session}
                    setInbox={setInbox}
                    isAllFilesSelected={isAllFilesSelected}
                    setIsAllFilesSelected={setIsAllFilesSelected}
                    setCheckedFiles={setCheckedFiles}
                    isFileChecked={isFileChecked}
                    handleCheckedFileChange={handleCheckedFileChange}
                    projectQueryValue={projectQueryValue}
                    filter={filter}
                    filesSortBy={filesSortBy}
                    filesSortingIsAscending={filesSortingIsAscending}
                    setFilesSortingIsAscending={setFilesSortingIsAscending}
                    folderId={folderId}
                    foldersLength={folders.length}
                    isAddFolderToProject={isAddFolderToProject}
                    isFilesUpdated={isFilesUpdated}
                    setIsFilesUpdated={setIsFilesUpdated}
                    setIsCountUpdated={setIsCountUpdated}
                    getStorageUsed={getStorageUsed}
                  />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                  <CustomTracksListContainer>
                    <TracksTableHeadings
                      filterAndSortParams={filterAndSortParams}
                      handleAscendingOrDescending={handleAscendingOrDescending}
                      isAllTracksSelected={isAllTracksSelected}
                      setCheckedTracks={setCheckedTracks}
                      tracks={tracks}
                      setIsAllTracksSelected={setIsAllTracksSelected}
                      isAddFolderToProject={isAddFolderToProject}
                    />
                    <CustomTracksScrollingContainer
                      sx={
                        isEnterpriseAccount
                          ? {
                              ...styles.bigScreenScrollC,
                              height: `calc(100vh - 280px - ${
                                folders.length === 0 ? 0 : folders.length < 8 ? 60 : 110
                              }px)`,
                            }
                          : {
                              ...styles.bigScreenScrollC,
                              height: 'calc(100vh - 230px)',
                            }
                      }
                      ref={!isSmallScreen ? scrollContainerRef : null}
                    >
                      {tracks &&
                        tracks.length > 0 &&
                        tracks.map((track, i) => {
                          return (
                            <TrackListView
                              key={i}
                              index={i}
                              track={track}
                              isBoxChecked={isBoxChecked}
                              handleCheckedTrackChange={handleCheckedTrackChange}
                              handleRefreshTracks={handleRefreshTracks}
                              handleOpenTrackVersionModal={handleOpenTrackVersionModal}
                              handleOpenSelectDeleteModal={handleOpenSelectDeleteModal}
                              handleOpenCollabsModal={handleOpenCollabsModal}
                              handleOpenEditTrackModal={handleOpenEditTrackModal}
                              setIsPlayButtonClicked={setIsPlayButtonClicked}
                              trackToPlay={trackToPlay}
                              setTrackToPlay={setTrackToPlay}
                              setIsTrackForPlay={setIsTrackForPlay}
                              setVersionToPlay={setVersionToPlay}
                              setAudioDetails={setAudioDetails}
                              session={session}
                              setInbox={setInbox}
                              handleExpandTrack={handleExpandTrack}
                              expanded={trackToExpand === track.track?.getId()}
                              handleDragStart={handleDragStart}
                              handleDrop={handleDrop}
                              setDraggedIndex={setDraggedIndex}
                              isReorderAvailable={isReorderAvailable}
                              handleOpenUpdateSubModal={handleOpenUpdateSubModal}
                              versionToPlay={versionToPlay}
                              isAddFolderToProject={isAddFolderToProject}
                              handleApplyFilterAndSort={handleApplyFilterAndSort}
                              shareToken={''}
                              allowDownload={true}
                            />
                          );
                        })}
                      {tracks.length === 0 && !isLoading && !isScrollEnabled && (
                        <Box sx={styles.emptyTracksContainer}>
                          <Typography>No tracks found!</Typography>
                        </Box>
                      )}
                      {isLoading && (
                        <Box
                          ref={loadingRef}
                          sx={{
                            ...styles.loadingContainer,
                            ...{ height: isSmallScreen ? '40vh' : 'auto' },
                          }}
                        >
                          <CircularProgress size={50} />
                        </Box>
                      )}
                    </CustomTracksScrollingContainer>
                  </CustomTracksListContainer>
                </CustomTabPanel>
                {/* B2C: Video panel hidden for individual users — enterprise only */}
                {isEnterpriseAccount && (
                  <CustomTabPanel value={value} index={3}>
                    <VideoUpload
                      getStorageUsed={getStorageUsed}
                      isFilesUpdated={isFilesUpdated}
                      setIsFilesUpdated={setIsFilesUpdated}
                      setUploadingFilesDetailsList={setUploadingFilesDetailsList}
                      setIsUploading={setIsUploading}
                      setUploadingCardsStatusList={setUploadingCardsStatusList}
                      setIsUploadProcessing={setIsUploadProcessing}
                      setIsCountUpdated={setIsCountUpdated}
                      projectId={projectId}
                    />
                  </CustomTabPanel>
                )}
              </Box>
            </Box>
          </Box>
        </TracksPageMainContainer>
      </Box>
      <Box sx={{ display: 'none' }} ref={ref} />
      <MobileScreenBottomNavigationContainer>
        <MobileScreenBottomNavigation />
      </MobileScreenBottomNavigationContainer>
      <AudioPlayer
        trackToPlay={trackToPlay}
        isPlayButtonClicked={isPlayButtonClicked}
        setIsPlayButtonClicked={setIsPlayButtonClicked}
        versionToPlay={versionToPlay}
        audioDetails={audioDetails}
        isTrackForPlay={isTrackForPlay}
        setTrackToPlay={setTrackToPlay}
        setVersionToPlay={setVersionToPlay}
      />
      <Modal
        open={isProjectNameModalOpen}
        onClose={handleCloseProjectNameModal}
        aria-labelledby="project-name-modal-title"
        aria-describedby="project-name-modal-description"
      >
        <Box
          sx={{
            ...addProjectModalStyles.modal,
            ...{
              width: isSmallScreen ? '100%' : 400,
            },
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <IconButton onClick={handleCloseProjectNameModal}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Typography
            sx={{ color: TEXT_COLOR, marginBottom: '20px' }}
            id="project-name-modal-title"
            variant="h6"
            component="h2"
          >
            Create Project from Folders
          </Typography>
          <Box sx={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
            {(['single', 'perFolder'] as const).map((mode) => (
              <Box
                key={mode}
                onClick={() => setCreateProjectMode(mode)}
                sx={{
                  flex: 1,
                  padding: '10px',
                  borderRadius: '6px',
                  border: createProjectMode === mode ? '2px solid #1976d2' : '1px solid #555',
                  cursor: 'pointer',
                  textAlign: 'center',
                  color: createProjectMode === mode ? '#1976d2' : TEXT_COLOR,
                  fontWeight: createProjectMode === mode ? 600 : 400,
                  fontSize: '13px',
                  userSelect: 'none',
                }}
              >
                {mode === 'single' ? 'All in one project' : 'One project per folder'}
              </Box>
            ))}
          </Box>
          {createProjectMode === 'single' ? (
            <>
              <Typography sx={{ color: TEXT_COLOR }}>
                Project Name
                <span className="asterisk">*</span>
              </Typography>
              <TextField
                error={isProjectNameEmptyError}
                onChange={(e) => {
                  setIsProjectNameEmptyError(false);
                  setNewProjectName(e.target.value);
                }}
                value={newProjectName}
                fullWidth
                placeholder="Enter Project Name"
                sx={{ marginTop: '5px' }}
              />
              <Typography sx={{ color: TEXT_COLOR, marginTop: '10px', fontSize: '14px' }}>
                {selectedFoldersForProjects.size} folder
                {selectedFoldersForProjects.size > 1 ? 's' : ''} will be added to this project
              </Typography>
            </>
          ) : (
            <Typography sx={{ color: TEXT_COLOR, fontSize: '14px', fontStyle: 'italic' }}>
              {selectedFoldersForProjects.size} project
              {selectedFoldersForProjects.size > 1 ? 's' : ''} will be created, each named after its
              folder
            </Typography>
          )}
          <Box sx={addProjectModalStyles.bottomContainer}>
            <CustomButton
              text="Create"
              onClick={
                createProjectMode === 'single'
                  ? handleBulkCreateProjects
                  : handleBulkCreateProjectsPerFolder
              }
              loading={isCreatingProjects}
              isDisabled={createProjectMode === 'single' && !newProjectName.trim()}
              customStyles={{ width: '48%' }}
            />
            <CustomButton
              text="Cancel"
              onClick={handleCloseProjectNameModal}
              isSkipButton={true}
              customStyles={{ width: '48%' }}
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};
